import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { SystemType } from '../../store/reducers/serviceCenters/types';

export const useIsXtimeIntegration = (): boolean => {
  const { shortSC } = useSelector((state: RootState) => state.serviceCenters);
  const { scProfile } = useSelector((state: RootState) => state.appointment);

  return useMemo(
    () => shortSC.find(sc => sc.id === scProfile?.id)?.system === SystemType.Xtime,
    [shortSC, scProfile?.id]
  );
};
